import apiClient from "./client.js";

// ---------------------------------------------------------------------------
// Alert rules (per monitor)
// ---------------------------------------------------------------------------

/**
 * List alert rules for a monitor.
 * @param {string} monitorId
 * @returns {Promise<Array>}
 */
export async function fetchAlertRules(monitorId) {
  const res = await apiClient.get(`/monitors/${monitorId}/alert-rules`);
  return res.data.data;
}

/**
 * Create an alert rule for a monitor.
 * @param {string} monitorId
 * @param {{ type: string, config: object }} data
 * @returns {Promise<object>}
 */
export async function createAlertRule(monitorId, data) {
  const res = await apiClient.post(`/monitors/${monitorId}/alert-rules`, data);
  return res.data.data;
}

/**
 * Delete an alert rule.
 * @param {string} monitorId
 * @param {string} ruleId
 */
export async function deleteAlertRule(monitorId, ruleId) {
  await apiClient.delete(`/monitors/${monitorId}/alert-rules/${ruleId}`);
}

/**
 * Fetch alert notification fire counts for a monitor.
 * @param {string} monitorId
 * @returns {Promise<{ data: Array, meta: { total_fires: number } }>}
 */
export async function fetchAlertNotifications(monitorId) {
  const res = await apiClient.get(`/monitors/${monitorId}/alert-notifications`);
  return res.data;
}

